import React from "react";
import { useTranslation } from "react-i18next";

import "./yourHealthyHospital.scss";

//Imagens:
import ImgYourHealthyHospital from "../../../../assets/health/health.png";
import SectionComponent from '../../../../components/utils/SectionComponent'


function YourHealthyHospital() {
  const { t } = useTranslation()
  
  return (
    <div className="container-your-healthy-hospital">
      <div className="img-your-healthy-hospital">
        <img src={ImgYourHealthyHospital} alt="" />
      </div>
      <div className="texts-your-healthy-hospital">
        <SectionComponent title={t("health.title")} text={t("health.section_text")} />
        <a href="/form">
          <button id="btn-your-healthy-hospital">{t("buttons.demo_btn_alternative_text_1")}</button>
        </a>
      </div>
    </div>
  );
}

export default YourHealthyHospital;
